import React from 'react';
import { HowToPlayModal } from '../../components/HowToPlayModal/HowToPlayModal';
import { WORD_RUNGS_WORD_LENGTH } from './wordRungsUtils';

export function HowToPlay({ onClose }) {
  return (
    <HowToPlayModal title="How to Play" titleId="word-rungs-how-title" onClose={onClose}>
      <p className="how-to-play-intro">
        Build a chain of <strong>{WORD_RUNGS_WORD_LENGTH}-letter words</strong>: each word must be in the
        dictionary and differ from the previous word by exactly one letter. Reach the goal from the start
        word.
      </p>
      <p className="how-to-play-intro">
        Daily puzzle is the same for everyone (local calendar day). Practice uses random solvable pairs.
      </p>
      <p className="how-to-play-intro">
        Score favors fewer steps and faster time.
      </p>
    </HowToPlayModal>
  );
}
